import { Component, ViewChild, Input, AfterViewInit, ViewEncapsulation, EventEmitter, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Renderer2 } from '@angular/core';

const noUiSlider = require('nouislider/distribute/nouislider.js');

@Component({
  selector: 'app-calendar-hours',
  templateUrl: './calendar-hours.component.html',
  styleUrls: ['./calendar-hours.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class CalendarHoursComponent implements AfterViewInit {
    noUiSlider: any;
    @Input() barId;
    @ViewChild('slider', { static: false }) slider;
    @Input() rangeFirstFrom;
    @Input() rangeFirstTo;
    @Input() enabled;
    @Input() mode;
    @Output() updatedHours: EventEmitter<Object> = new EventEmitter<Object>();
    @Output() removeDay: EventEmitter<Object> = new EventEmitter<Object>();
    public range: string;

    constructor(private renderer2: Renderer2) {
    }

    ngAfterViewInit() {
        const slider = document.getElementById(this.barId);
        noUiSlider.create(this.slider.nativeElement, {
            start: [
                this.convertTimeToValue(this.rangeFirstFrom),
                this.convertTimeToValue(this.rangeFirstTo),
            ],
            connect: [false, true, false, true, false],
            behaviour: 'drag-tap',
            range: {
                'min': 0,
                'max': 1439
            },
            'step': 10,
        });


        this.noUiSlider = this.slider.nativeElement.noUiSlider;
        this.noUiSlider.target.hidden = !this.enabled;
        this.noUiSlider.on('update', (values, handle) => {
            this.convertValuesToTime(values, handle);
        });

        if (this.mode === 'caregiver') {
            this.renderer2.setAttribute(this.slider.nativeElement, 'disabled', 'true');
        }
    }

    private convertTimeToValue(hourlyFormat: string): number {
        const hours = parseInt(hourlyFormat.substr(0, hourlyFormat.indexOf(':')), 10);
        const minutes = parseInt(hourlyFormat.substr(hourlyFormat.indexOf(':') + 1, hourlyFormat.length), 10);
        return hours * 60 + minutes;
    }


    private convertValuesToTime(values, handle): void {

        this.rangeFirstFrom = this.formatTime(values[0]);
        this.rangeFirstTo = this.formatTime(values[1]);
        let message;

        // jeden ciag pracowania
        if (values[1] === values[2] || values[1] === values[2] === values[3] || values[0] === values[1] === values[2]) {

            message = this.rangeFirstFrom;
            setTimeout(() => this.range = '(' + this.rangeFirstFrom  + ')');

            this.updatedHours.emit({
                type: 1,
                from: this.rangeFirstFrom,
                enabled: this.enabled
            });

        } else {

            if (this.rangeFirstFrom === this.rangeFirstTo) {
                message = '00:00 - 00:00';
            } else {
                message = this.rangeFirstFrom + ' - ' + this.rangeFirstTo + ')';
            }
            setTimeout(() => this.range = '(' + message + ')');

            this.updatedHours.emit({
                type: 2,
                fromFirst: this.rangeFirstFrom,
                toFirst: this.rangeFirstTo,
                enabled: this.enabled
            });

        }

    }

    private formatTime(minutes): string {
        let hour, minute;

        hour = Math.floor(minutes / 60);
        minute = minutes - (hour * 60);

        if (hour < 10) {
            hour = '0' + hour;
        }
        if (minute < 10) {
            minute = '0' + minute;
        }

        return hour + ':' + minute;
    }

    public setEnabled(): void {
        this.enabled = true;
        this.noUiSlider.target.hidden = !this.enabled;
        this.noUiSlider.set([0, 0, 1439, 1439]);
    }

    public disableEnabled(): void {
        this.enabled = false;
        this.noUiSlider.target.hidden = !this.enabled;
        this.noUiSlider.set([0, 0]);
    }


}